import React, { useEffect, useState } from 'react';

export default function LoadingScreen({ message = 'Inicializando...', timeout = 10000 }) {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    // Si el loading dura más del timeout, mostrar error
    const timer = setTimeout(() => {
      setShowError(true);
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout]);

  if (showError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black">
        <div className="text-center max-w-md">
          <img 
            src="/kompa-logo.png" 
            alt="Kompa" 
            className="h-24 w-auto mx-auto mb-6"
          />
          <div className="bg-red-900/20 border border-red-500/30 rounded-lg p-6">
            <p className="text-red-400 text-lg font-semibold mb-3">
              ⚠️ Tiempo de carga excedido
            </p>
            <p className="text-gray-400 text-sm mb-4">
              La aplicación está tardando más de lo esperado en cargar.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold rounded transition-colors"
            >
              Reintentar
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black">
      <div className="text-center">
        {/* Logo de Kompa */}
        <div className="mb-8">
          <img 
            src="/kompa-logo.png" 
            alt="Kompa" 
            className="h-24 w-auto mx-auto animate-pulse"
          />
        </div>
        
        {/* Spinner */}
        <div className="relative mx-auto w-16 h-16 mb-6">
          <div className="absolute inset-0 border-4 border-yellow-500/30 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-yellow-500 rounded-full animate-spin"></div>
        </div>
        
        {/* Mensaje */}
        <div className="space-y-2">
          <p className="text-yellow-500 text-xl font-semibold">{message}</p>
          <div className="flex items-center justify-center gap-1">
            <span className="w-2 h-2 bg-yellow-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
            <span className="w-2 h-2 bg-yellow-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
            <span className="w-2 h-2 bg-yellow-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
          </div>
        </div>
      </div>
    </div>
  );
}
